import { createTaskConverter, newTaskConverter } from '@griply/services';
import { Task } from '@griply/types';
import { resolveI18nLanguage } from '@griply/utils';
import { FirestoreDataConverter } from 'firebase/firestore';
import i18n from 'shared/lib/react-i18next';

import { getErrorReporter } from '../../error-tracking';

export const taskConverter = createTaskConverter({
  onError: (error, context) =>
    getErrorReporter().captureException(error, {
      tags: { source: 'task-converter-read' },
      extra: context,
    }),
  getLanguage: () => resolveI18nLanguage(i18n),
}) as unknown as FirestoreDataConverter<Task>;
export { newTaskConverter };
